import { SupplementaryEquipmentComponent } from './component/supplementary-equipment/supplementary-equipment.component';
import { TransportOptionsComponent } from './component/transport-options/transport-options.component';
import { RouteComponent } from './component/route/route.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationComponent } from './component/registration.component';
import {  ServiceResponseModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MasterDataComponent } from './component/master-data/master-data.component';
import { TransportOptionsEditorModule } from '../../components/transport-options-editor/transport-options-editor.module';
import { CommonTranslationModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { TransportOptionsPanelModule } from '../transport-options-panel/transport-options-panel.module';
import { TransportDetailsModule } from '../../common/components/transport-details/transport-details.module';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';


@NgModule({
  imports: [
    CommonModule,

    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportDetailsModule,
    TransportOptionsEditorModule,
    TransportOptionsPanelModule,
    CommonTranslationModule,
    ServiceResponseModule,
    ApplicationClientCommonModule,
    MatSelectModule,
    MatTooltipModule,
    DragDropModule,
    MatCheckboxModule,
    MatInputModule
  ],
  declarations: [
    RegistrationComponent,
    MasterDataComponent,
    RouteComponent,
    TransportOptionsComponent,
    SupplementaryEquipmentComponent,
    MasterDataComponent
  ],
  exports: [
    RegistrationComponent,
    MasterDataComponent,
    RouteComponent,
    TransportOptionsComponent,
    SupplementaryEquipmentComponent
  ]
})
export class TransportRegistrationModule { }
